// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2hfIj","footer":"ModalError_footer__2D26M"};